import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { ItemsCarousel } from '../NewbuildingRecommendations';
import type { IRecommendations } from '../../types/newbuildingRecommendations';
import { RedesignedNewbuildingRecommendationCard } from './RedesignedNewbuildingRecommendationCard';
import * as styles from './RedesignedNewbuildingRecommendations.css';

type TRedesignedNewbuildingRecommendationsProps = {
  recommendations: IRecommendations[];
  onCardClick(params: { newbuildingId: number; position: number }): () => void;
};

export const RedesignedNewbuildingRecommendations: React.FC<TRedesignedNewbuildingRecommendationsProps> = ({
  recommendations,
  onCardClick,
}) => {
  const renderOutside = React.useCallback(
    () =>
      recommendations.map((recommendation, index) => (
        <li key={recommendation.id}>
          <RedesignedNewbuildingRecommendationCard
            recommendation={recommendation}
            onClick={onCardClick({ newbuildingId: recommendation.id, position: index })}
          />
        </li>
      )),
    [onCardClick, recommendations],
  );

  return (
    <section
      data-testid="RedesignedNewbuildingRecommendations"
      data-name="RedesignedNewbuildingRecommendations"
      className={styles['section']}
    >
      <div className={styles['header']}>
        <UIHeading1>Популярные жилые комплексы от застройщиков</UIHeading1>
      </div>
      <div className={styles['carousel-wrapper']}>
        <ItemsCarousel scrollVisible styles={styles['carousel']} renderOutside={renderOutside} />
      </div>
    </section>
  );
};
